import React, { useState } from 'react';
import moment from 'moment';
import swal from 'sweetalert';
import InputMask from 'components/ui/InputMaskCustom';
import Button from 'components/ui/Button';
import DatePicker from 'components/ui/DatePicker';
import Api from 'api/Api';
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Grid,
} from '@material-ui/core';
import {
  exportReport,
  formatAmount,
  getHumanJsDateFormat,
} from 'functions/helpers';

const tableHead = ['Номер терминала', 'Дата инкассации', 'Сумма инкассации'];
let tableHeadKey = 0;
let resultKey = 0;

const Encashments = () => {
  const [idTerminal, setIdTerminal] = useState('');
  const [dateFrom, setDateFrom] = useState(
    new Date(moment().subtract(1, 'days'))
  );
  const [dateTo, setDateTo] = useState(new Date());
  const [resultTable, setResultTable] = useState([]);

  const search = () => {
    if (!idTerminal) {
      return swal('', 'Номер терминала обязателен к заполнению', 'warning');
    }

    Api.getReport(
      'encashments',
      JSON.stringify({
        idTerminal: String(idTerminal).trim(),
        dateFrom: moment(dateFrom).format('YYYY-MM-DD HH:00:00'),
        dateTo: moment(dateTo).format('YYYY-MM-DD HH:59:00'),
      })
    ).then((response) => {
      if (typeof response !== 'undefined') {
        if (response !== null) {
          setResultTable(response);
        } else {
          swal('', 'Не найдено инкассаций за выбранный период', 'warning');
          setResultTable([]);
        }
      }
    });
  };

  const handleChangeDateFrom = (date) => {
    setDateFrom(date);
  };

  const handleChangeDateTo = (date) => {
    setDateTo(date);
  };

  const exportDataHandler = () => {
    exportReport(resultTable, 'encashments');
  };

  return (
    <>
      <Grid container spacing={3}>
        <Grid sm={3} xs={12} item>
          <div className="customInp">
            <InputMask
              type="tel"
              name="idTerminal"
              callback={(e) => setIdTerminal(e.target.value.trim())}
              placeholder="Номер терминала"
              mask="999999999"
              id="account"
            />
          </div>
        </Grid>
        <Grid sm={3} xs={6} item>
          <DatePicker selected={dateFrom} onChange={handleChangeDateFrom} />
        </Grid>
        <Grid sm={3} xs={6} item>
          <DatePicker selected={dateTo} onChange={handleChangeDateTo} />
        </Grid>
        <Grid sm={1} xs={12} item>
          <Button color="primary" onClick={search} className="noMarg" fullWidth>
            Найти
          </Button>
        </Grid>
        <Grid item sm={2} align="top">
          <Button
            color="primary"
            fullWidth
            className="noMarg"
            onClick={exportDataHandler}
            disabled={!resultTable?.length}
          >
            Экспорт в Excel
          </Button>
        </Grid>
      </Grid>

      {resultTable?.length ? (
        <>
          <h2>Количество найденных инкассаций: {resultTable?.length}</h2>
          <br />
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  {tableHead.map((item) => (
                    <TableCell key={tableHeadKey++}>{item}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {resultTable.map(({ idTerminal, amount, dateIn }) => (
                  <TableRow key={resultKey++}>
                    <TableCell>{idTerminal.String}</TableCell>
                    <TableCell>{getHumanJsDateFormat(dateIn.String)}</TableCell>
                    <TableCell>{formatAmount(amount.String)} тг</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      ) : null}
    </>
  );
};

export default Encashments;
